import { DocumentPreviewToolbarActions } from './document-preview-toolbar-actions';
import { DocxViewerPreview } from './extend-ui/ui/docx-viewer';

export function DocxArtifactPreview({
  fileUrl,
  fitToPaneRequestId,
  onClose,
  onUserZoomChange,
  sourceUrl,
  title,
}: {
  fileUrl: string;
  fitToPaneRequestId?: number;
  onClose: () => void;
  onUserZoomChange?: () => void;
  sourceUrl: string;
  title: string;
}) {
  return (
    <DocxViewerPreview
      className="h-full min-h-[480px]"
      defaultZoom={100}
      fitToPaneRequestId={fitToPaneRequestId}
      fileName={title}
      forceInlineThumbnailSidebar
      isDark={false}
      onIsDarkChange={() => undefined}
      onUserZoomChange={onUserZoomChange}
      showActionsMenu={false}
      showToolbar
      showUpload={false}
      src={sourceUrl}
      toolbarActions={<DocumentPreviewToolbarActions fileUrl={fileUrl} onClose={onClose} />}
      toolbarMode="minimal"
    />
  );
}
